const accordions = document.querySelectorAll(".accordion");

if (accordions) {
  accordions.forEach((acc) => {
    // Toggle Button
    const toggle = acc.querySelector(".accordion__toggle");
    // Content
    const content = acc.querySelector(".accordion__content");
    // Add eventlistener to toggle button
    toggle.addEventListener("click", (e) => {
      if (!acc.classList.contains("accordion--active")) {
        // Expand accordion content
        acc.classList.add("accordion--active");
        toggle.setAttribute("title", "Accordion zuklappen");
        toggle.setAttribute("aria-label", "Accordion zuklappen");
        toggle.setAttribute("aria-pressed", true);
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.setAttribute("aria-expanded", true);
      } else {
        // Hide accordion content
        acc.classList.remove("accordion--active");
        toggle.setAttribute("title", "Accordion aufklappen");
        toggle.setAttribute("aria-label", "Accordion aufklappen");
        toggle.setAttribute("aria-pressed", false);
        content.style.maxHeight = `0px`;
        content.setAttribute("aria-expanded", false);
      }
    });
  });
}
